export const US_STATES = [
  { abbrev: "AL", name: "Alabama" },
  { abbrev: "AK", name: "Alaska" },
  { abbrev: "AZ", name: "Arizona" },
  { abbrev: "AR", name: "Arkansas" },
  { abbrev: "CA", name: "California" },
  { abbrev: "CO", name: "Colorado" },
  { abbrev: "CT", name: "Connecticut" },
  { abbrev: "DE", name: "Delaware" },
  { abbrev: "FL", name: "Florida" },
  { abbrev: "GA", name: "Georgia" },
  { abbrev: "HI", name: "Hawaii" },
  { abbrev: "ID", name: "Idaho" },
  { abbrev: "IL", name: "Illinois" },
  { abbrev: "IN", name: "Indiana" },
  { abbrev: "IA", name: "Iowa" },
  { abbrev: "KS", name: "Kansas" },
  { abbrev: "KY", name: "Kentucky" },
  { abbrev: "LA", name: "Louisiana" },
  { abbrev: "ME", name: "Maine" },
  { abbrev: "MD", name: "Maryland" },
  { abbrev: "MA", name: "Massachussetts" },
  { abbrev: "MI", name: "Michigan" },
  { abbrev: "MN", name: "Minnesota" },
  { abbrev: "MS", name: "Mississippi" },
  { abbrev: "MO", name: "Missouri" },
  { abbrev: "MT", name: "Montana" },
  { abbrev: "NE", name: "Nebraska" },
  { abbrev: "NV", name: "Nevada" },
  { abbrev: "NH", name: "New Hampshire" },
  { abbrev: "NJ", name: "New Jersey" },
  { abbrev: "NM", name: "New Mexico" },
  { abbrev: "NY", name: "New York" },
  { abbrev: "NC", name: "North Carolina" },
  { abbrev: "ND", name: "North Dakota" },
  { abbrev: "OH", name: "Ohio" },
  { abbrev: "OK", name: "Oklahoma" },
  { abbrev: "OR", name: "Oregon" },
  { abbrev: "PA", name: "Pennsylvania" },
  { abbrev: "RI", name: "Rhode Island" },
  { abbrev: "SC", name: "South Carolina" },
  { abbrev: "SD", name: "South Dakota" },
  { abbrev: "TN", name: "Tennessee" },
  { abbrev: "TX", name: "Texas" },
  { abbrev: "UT", name: "Utah" },
  { abbrev: "VT", name: "Vermont" },
  { abbrev: "VA", name: "Virginia" },
  { abbrev: "WA", name: "Washington" },
  { abbrev: "WV", name: "West Virginia" },
  { abbrev: "WI", name: "Wisconsin" },
  { abbrev: "WY", name: "Wyoming" },
];

export const galleryLinks = [
  {
    key: ["folding"],
    name: "Folding Doors",
    url: "/products/folding-doors",
    materials: [
      { name: "Aluminum", url: "/products/folding-doors/aluminum" },
      // Note about the below "duplicate":
      // ultimately these tags need to be all one way or all the other but due
      // to some bugs in asset manager preventing easy manipulation (as of 9/24/2021) this should cover us fine.
      {name: "LC: Aluminum", alias: "Aluminum", url: "/products/folding-doors/aluminum"},
      { name: "Aluminum Thermally Controlled", url: "/products/folding-doors/aluminum-thermally-controlled" },
      { name: "Aluminum Wood", url: "/products/folding-doors/aluminum-wood" },
      { name: "Contemporary Clad", url: "/products/folding-doors/contemporary-clad" },
      { name: "Wood", url: "/products/folding-doors/wood" },
      { name: "Vinyl", url: "/products/folding-doors/vinyl" },
    ],
  },
  {
    key: ["sliding"],
    name: "Sliding Doors",
    url: "/products/sliding-doors",
    materials: [
      { name: "Aluminum", url: "/products/sliding-doors/aluminum" },
      { name: "Aluminum Thermally Controlled", url: "/products/sliding-doors/aluminum-thermally-controlled" },
      { name: "Aluminum Wood", url: "/products/sliding-doors/aluminum-wood" },
      { name: "Contemporary Clad", url: "/products/sliding-doors/contemporary-clad" },
    ],
  },
  {
    key: ["swing", "swinging"],
    name: "Swing Doors",
    url: "/products/swing-doors",
    materials: [
      { name: "Aluminum", url: "/products/swing-doors/aluminum" },
      { name: "Aluminum Thermally Controlled", url: "/products/swing-doors/aluminum-thermally-controlled" },
      { name: "Aluminum Wood", url: "/products/swing-doors/aluminum-wood" },
      { name: "Contemporary Clad", url: "/products/swing-doors/contemporary-clad" },
      { name: "Wood", url: "/products/swing-doors/wood" },
    ],
  },
  {
    key: ["screens"],
    name: "Screens",
    url: "/products/screens",
    materials: [
      { name: "Pleated", url: "/products/screens/pleated" },
      { name: "Non-Pleated", url: "/products/screens/non-pleated" },
    ],
  },
]